import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";

export const getLocalTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const zonedTimeToUTC = (date: Date) => {
  const timeZone = getLocalTimezone();
  return zonedTimeToUtc(date, timeZone);
};

export const UTCToZonedTime = (date: Date) => {
  const timeZone = getLocalTimezone();
  return utcToZonedTime(date, timeZone);
};


// Get current time in UTC+0
export const getCurrentTimeInUTCZero = (): string => {
  return new Date().toISOString(); 
};

// Convert any date to UTC+0 and return as ISO string
export const convertToUTCZero = (date: Date | string): string => {
  const parsedDate = typeof date === "string" ? new Date(date) : date;
  return parsedDate.toISOString();
};
